/** @jsx jsx */
// External libraries
import { css, jsx } from '@emotion/core';
// @ts-expect-error untyped import
import { TextButtonWithUnderline } from '@checkout/react-components';
import { useStoreState } from '@/store';
// @ts-expect-error untyped import
import { LoadingElement } from '@checkout/react-components';

// Internal modules
import { getContent, getLocale } from '@/lib';
import { CountryAsTextContainer } from './StyledComponents';

const changeButtonStyleOverrides = css`
  line-height: 1;
  margin-left: 8px;
  text-decoration: none;
`;

type CountryAsTextProps = {
  clickHandler: () => void;
  isFormSubmitting: boolean;
};

const CountryAsText = (props: CountryAsTextProps): JSX.Element => {
  const { country: globalCountry, locale } = getLocale();

  const country = useStoreState(({ api }) => {
    const countryList = api.griffinMetadata.territories[locale];
    return (
      countryList && countryList.find(country => country.key === globalCountry)
    );
  });

  if (!country) {
    return <LoadingElement />;
  }

  return (
    <CountryAsTextContainer data-testid="country-as-text">
      {country.text}
      <TextButtonWithUnderline
        disabled={props.isFormSubmitting}
        onClick={props.clickHandler}
        styleOverrides={changeButtonStyleOverrides}
      >
        {getContent('base.change')}
      </TextButtonWithUnderline>
    </CountryAsTextContainer>
  );
};

export { CountryAsText };
